import { FC, useCallback, useMemo, useState } from 'react';
import { ScrollView, View, Image } from 'react-native';
import { STYLE_VARS } from '../../constants/style-vars';
import { useIsDesktop } from '../../hooks/useIsDeskTop';
import { User } from './components/User';
import { Text } from '../../components/Text';
import { myAccountStyled } from './styled';
import { RequestForm } from './components/RequestForm';
import { Footer } from '../../components/Footer';
import TabBar from './components/TabBar';
import MyAccountLayout from '../../components/MyAccountLayout/MyAccountLayout';
import PageTitle from '../../components/PageTitle';
import { IRequestForm } from './types';
import * as yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../services/redux';
import { AuthApi } from '../../services/api/auth.api';
import { Alert } from '../../services/alert';
import { NavigationService } from '../../services/navigation';
import { Button } from '../../components/Button';
import { IS_IOS, SCREEN_HEIGHT, SCREEN_WITDH } from '../../constants/platform';
import { logout } from '../../services/redux/reducers/AuthSlice';
import { Loading } from '../../components';
import { setIsShowStart } from '../../services/redux/reducers/SwitchECardSlice';

const MyAccount: FC = () => {
  const isDesktop = useIsDesktop();
  const dispatch = useDispatch();
  const { info } = useSelector((redux: RootState) => redux.authReducer);
  const [isLoading, setIsLoading] = useState(false);

  const requestForm: IRequestForm[] = useMemo(
    () => [
      {
        formStructer: {
          key: 'username',
          title: 'username',
          description: '',
          components: [
            {
              type: 'text',
              name: 'username',
              label: 'User name',
              placeholder: 'User name',
              validation: yup.string().required('User name is required'),
            },
            {
              type: 'submit',
              name: 'request',
              label: 'SAVE',
              placeholder: '',
            },
          ],
        },
        onSubmit: async (data) => {
          await AuthApi.updateProfile(data)
            .then((value) => {
              Alert.alert('Success', value.data.message);
            })
            .catch((error) => {
              Alert.alert('Error', error.message[0]);
            });
        },
        initValues: {
          username: info?.user_login,
        },
      },
      {
        formStructer: {
          key: 'email',
          title: 'email',
          description: '',
          components: [
            {
              type: 'text',
              name: 'new_email',
              label: 'Email',
              placeholder: 'Email',
              validation: yup
                .string()
                .required('Email is required')
                .email('Wrong email format!'),
            },
            {
              type: 'submit',
              name: 'request',
              label: 'SAVE',
              placeholder: '',
            },
          ],
        },
        onSubmit: async (data) => {
          await AuthApi.updateProfile(data)
            .then((value) => {
              Alert.alert('Success', value.data.message);
            })
            .catch((error) => {
              Alert.alert('Error', error.message[0]);
            });
        },
        initValues: {
          new_email: info?.user_email,
        },
      },
      {
        formStructer: {
          key: 'password',
          title: 'password',
          description: '',
          components: [
            {
              type: 'text',
              name: 'password',
              label: 'Current Password',
              placeholder: 'Current Password',
              validation: yup.string().required('Current Password is required'),
              secureTextEntry: true,
            },
            {
              type: 'text',
              name: 'new_password',
              label: 'New Password',
              placeholder: 'New Password',
              validation: yup
                .string()
                .required('New Password is required')
                .min(8, 'At lease 8 letters')
                .matches(/[A-Z]/, 'At least one capital letter')
                .matches(
                  /[0-9\W_]/,
                  'Contains a number or a special character'
                ),
              secureTextEntry: true,
            },
            {
              type: 'text',
              name: 're_password',
              label: 'New Password Repeat',
              placeholder: 'New Password Repeat',
              validation: yup
                .string()
                .required('New Password Repeat is required')
                .oneOf(
                  [yup.ref('new_password'), ''],
                  'New Password Repeat must match'
                ),
              secureTextEntry: true,
            },
            {
              type: 'submit',
              name: 'request',
              label: 'SAVE',
              placeholder: '',
            },
          ],
        },
        onSubmit: async (data) => {
          await AuthApi.updateProfile({
            password: data.password,
            new_password: data.new_password,
          })
            .then((value) => {
              Alert.alert('Success', value.data.message);
            })
            .catch((error) => {
              Alert.alert('Error', error.message[0]);
            });
        },
      },
      {
        formStructer: {
          key: 'memberDetails',
          title: 'member details',
          description: '',
          components: [
            {
              type: 'text',
              name: 'memb_sal',
              label: 'Salutation',
              placeholder: 'Salutation',
              validation: yup.string().required('Salutation is required'),
            },
            {
              type: 'text',
              name: 'memb_suv',
              label: 'Surname',
              placeholder: 'Surname',
              validation: yup.string().required('Surname is required'),
            },
            {
              type: 'text',
              name: 'memb_giv',
              label: 'Given name',
              placeholder: 'Given name',
              validation: yup.string().required('Given name is required'),
            },
            {
              type: 'text',
              name: 'memb_alias',
              label: 'Alias',
              placeholder: 'Alias',
            },
            {
              type: 'text',
              name: 'memb_osal',
              label: 'Chinese Salutation',
              placeholder: 'Chinese Salutation',
            },
            {
              type: 'text',
              name: 'memb_osuv',
              label: 'Chinese Surname',
              placeholder: 'Chinese Surname',
            },
            {
              type: 'text',
              name: 'memb_ogiv',
              label: 'Chinese Given Name',
              placeholder: 'Chinese Given Name',
            },
            {
              type: 'submit',
              name: 'request',
              label: 'REQUEST UPDATE',
              placeholder: '',
            },
          ],
        },
        initValues: {
          memb_sal: info?.details.member.CARD_SAL,
          memb_giv: info?.details.member.CARD_GIV,
          memb_suv: info?.details.member.CARD_SUR,
          memb_alias: info?.details.member.CARD_ALIAS,
          memb_osal: info?.details.member.CARD_OSAL,
          memb_osuv: info?.details.member.CARD_OSUR,
          memb_ogiv: info?.details.member.CARD_OGIV,
        },
        onSubmit: async (data) => {
          await AuthApi.updateProfile({
            details: data,
          })
            .then((value) => {
              Alert.alert('Success', value.data.message);
            })
            .catch((error) => {
              Alert.alert('Error', error.message);
            });
        },
      },
      {
        formStructer: {
          key: 'spouseDetails',
          title: 'spouse details',
          description: '',
          components: [
            {
              type: 'text',
              name: 'memb_smobi',
              label: 'Mobile',
              placeholder: 'Mobile',
              validation: yup.string().required('Mobile is required'),
            },
            {
              type: 'text',
              name: 'memb_spcon',
              label: 'Company Name',
              placeholder: 'Company Name',
            },
            {
              type: 'text',
              name: 'memb_sppos',
              label: 'Business position',
              placeholder: 'Business Position',
            },
            {
              type: 'text',
              name: 'memb_spbte',
              label: 'Business phone',
              placeholder: 'Business Phone',
            },
            {
              type: 'text',
              name: 'memb_smail',
              label: 'Business email',
              placeholder: 'Business Email',
            },
            {
              type: 'text',
              name: 'memb_srmal',
              label: 'Personal email',
              placeholder: 'Personal Email',
              validation: yup.string().required('Personal email is required'),
            },
            {
              type: 'submit',
              name: 'request',
              label: 'REQUEST UPDATE',
              placeholder: '',
            },
          ],
        },
        initValues: {
          memb_smobi: info?.details.spouse.CARD_MOBIL,
          memb_spcon: info?.details.spouse.MEMB_SPCON,
          memb_sppos: info?.details.spouse.MEMB_SPPOS,
          memb_spbte: info?.details.spouse.MEMB_SPBTE,
          memb_smail: info?.details.spouse.MEMB_SMAIL,
          memb_srmal: info?.details.spouse.MEMB_SRMAL,
        },
        onSubmit: async (data) => {
          await AuthApi.updateProfile({
            details: data,
          })
            .then((value) => {
              Alert.alert('Success', value.data.message);
            })
            .catch((error) => {
              Alert.alert('Error', error.message);
            });
        },
      },
      {
        formStructer: {
          key: 'emergencyContact',
          title: 'emergency contact',
          description: '',
          components: [
            {
              type: 'text',
              name: 'memb_ecna',
              label: 'Contact Name 1',
              placeholder: 'Contact Name 1',
              validation: yup.string().required('Contact Name 1 is required'),
            },
            {
              type: 'text',
              name: 'memb_ecno',
              label: 'Phone 1',
              placeholder: 'Phone 1',
              validation: yup.string().required('Phone 1 is required'),
            },
            {
              type: 'text',
              name: 'memb_ecrel',
              label: 'Relationship 1',
              placeholder: 'Relationship 1',
              validation: yup.string().required('Relationship 1 is required'),
            },
            {
              type: 'text',
              name: 'memb_ecna2',
              label: 'Contact Name 2',
              placeholder: 'Contact Name 2',
              validation: yup.string().required('Contact Name 2 is required'),
            },
            {
              type: 'text',
              name: 'memb_ecno2',
              label: 'Phone 2',
              placeholder: 'Phone 2',
              validation: yup.string().required('Phone 2 is required'),
            },
            {
              type: 'text',
              name: 'memb_ecrel2',
              label: 'Relationship 2',
              placeholder: 'Relationship 2',
              validation: yup.string().required('Relationship 2 is required'),
            },
            {
              type: 'submit',
              name: 'request',
              label: 'REQUEST UPDATE',
              placeholder: '',
            },
          ],
        },
        initValues: {
          memb_ecna: info?.details.member.MEMB_ECNA,
          memb_ecno: info?.details.member.MEMB_ECNO,
          memb_ecrel: info?.details.member.MEMB_ECREL,
          memb_ecna2: info?.details.member.MEMB_ECNA2,
          memb_ecno2: info?.details.member.MEMB_ECNO2,
          memb_ecrel2: info?.details.member.MEMB_ECREL2,
        },
        onSubmit: async (data) => {
          await AuthApi.updateProfile({
            details: data,
          })
            .then((value) => {
              Alert.alert('Success', value.data.message);
            })
            .catch((error) => {
              Alert.alert('Error', error.message);
            });
        },
      },
    ],
    [info]
  );

  const handleDeleteAccount = useCallback(() => {
    Alert.alert(
      'Delete Account',
      "Are you sure you'd like to Delete Your account on the KCC Members App?",
      [
        {
          text: 'Confirm',
          onPress: async () => {
            try {
              setIsLoading(true);
              await AuthApi.deleteAccount();
              dispatch(logout());
              dispatch(setIsShowStart(false));
              NavigationService.push('Login');
              Alert.alert(
                'Delete success',
                'Thanks, your account on the KCC Mobile App has been successfully deleted'
              );
            } catch (error) {
              Alert.alert('Delete account fail', 'Please try again later');
            } finally {
              setIsLoading(false);
            }
          },
        },
        {
          text: 'Cancel',
        },
      ]
    );
  }, [dispatch]);

  if (isDesktop()) {
    return (
      <MyAccountLayout
        title="My account"
        current={0}
        icon={require('../../assets/my-account.png')}
      >
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'flex-start',
            // justifyContent:'space-between'
          }}
        >
          <View style={{ width: '30%', maxWidth: 250, minWidth: 200 }}>
            <User />
          </View>
          <View
            style={{
              marginTop: 20,
              paddingLeft: 10,
              width: '50%',
              maxWidth: 400,
            }}
          >
            <View
              style={{
                marginTop: 10,
                marginBottom: 24,
              }}
            >
              <Text style={myAccountStyled.carInfoText}>Car Registration</Text>
            </View>
            <View
              style={{
                backgroundColor: STYLE_VARS.fccLightGrey,
                borderRadius: 6,
                padding: 10,
                marginBottom: 40,
              }}
            >
              <Text style={myAccountStyled.carInfoText}>
                Kia sorento{'\n'}vh12345
              </Text>
            </View>
          </View>
        </View>
        <View style={{ marginTop: 20 }}>
          <RequestForm formSections={requestForm} />
        </View>
      </MyAccountLayout>
    );
  }

  return (
    <View style={{ flex: 1 }}>
      <ScrollView showsVerticalScrollIndicator={false}>
        <View style={myAccountStyled.container}>
          <PageTitle
            icon={require('../../assets/my-account.png')}
            title="MY ACCOUNT"
            haveGoBackButton={true}
            handleGoBack={() => {
              NavigationService.push('Root', {
                screen: 'HomeTab',
              });
            }}
          />
        </View>
        <View style={myAccountStyled.container}>
          <User />
        </View>
        <TabBar />
        <View style={[myAccountStyled.container, { marginTop: 20 }]}>
          <RequestForm formSections={requestForm} />
        </View>
        {IS_IOS && (
          <View style={{ marginBottom: 20 }}>
            <Button
              text="Delete account"
              style={STYLE_VARS.blueButton}
              onPress={handleDeleteAccount}
            />
          </View>
        )}
        <Footer />
      </ScrollView>
      {isLoading && (
        <View style={myAccountStyled.loadingScreen}>
          <Loading color="white" />
        </View>
      )}
    </View>
  );
};

export default MyAccount;
